import headers from '../../../../configs/savedProspectsTable.json'
import {useSavedProspectsList} from '../../../../api/getSavedProspectList'
import {useCallback, useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {savedProspectsCount} from '../../../../store/prospectSegment/allProspectsCount/allProspectsCountSlice'
import {allSavedProspectsList} from '../../../../store/prospectSegment/savedProspectsList/saveProspectsListSlice'
import TableComponent from '../../../Common/TableComponent/TableComponentIndex'
import {updatedSavedProspectsSearchTerm} from '../../../../store/search/searchSlice'
import {selectSearchTerm} from '../../../Common/MappingHelperConst'
import {getSavedProspectsPageNumber} from '../../../../store/pagination/pageNumberSlice'
import {
  getAllProspectsData,
  getAllSavedProspectsData
} from '../../../../store/prospectSegment/allProspectsData/allProspectsDataSlice'
import prospectsActions from '../../../../configs/prospectsAction.json'
import {setAddToSavedProspects} from '../../../../store/prospectSegment/addToSavedProspects/addToSavedProspectsSlice'
import {useDeleteSavedList} from '../../../../api/deleteSavedList'
import {CircularProgress} from '@mui/material'
import {StyledBox} from '../Styles'
import SearchPanel from '../../../Common/SearchPanel/SearchPanelIndex'
import {StyledBackdrop} from '../AllProspects/AddToSavedProspects/AddToSavedProspectsStyles'
import paginationLimit from '../../../../configs/paginationLimit.json'
import {setCampaignAction} from '../../../../store/selectedView/campaignView/campaignActionSlice'
import ConfirmationPopup from './ConfirmationPopup/ConfirmationPopupIndex'
import {setCampaignView} from '../../../../store/selectedView/campaignView/campaignViewIndex'
import {setAllConstituentsFilters} from '../../../../store/prospectSegment/openSavedProspect/openSavedProspectSlice'
import PropTypes from 'prop-types'

const SavedProspects = ({
  height,
  showAddColumnHeader = prospectsActions.savedProspects.addColumnRequired,
  showCheckboxes = prospectsActions.savedProspects.checkBoxRequired,
  hasActions = prospectsActions.savedProspects.hasActions,
  hasAccordian = prospectsActions.savedProspects.hasAccordian,
  searchPanelRequired = true
}) => {
  const data = useSelector((state) => state.getAllProspectsData.getSavedList)
  const [conditionalSavedList, {data: savedProspectList, loading, error}] = useSavedProspectsList()
  const dispatch = useDispatch()
  const currentSelectedTab = useSelector((state) => state.selectedProspectTab.value)
  const searchTermSelector = selectSearchTerm.find((item) => item.contentKey === currentSelectedTab)
  const searchString = useSelector((state) => state.search[searchTermSelector.selectorContent])
  const {previousTerm, currentTerm} = searchString

  const totalCount = useSelector((state) => state.totalProspectsCount.savedProspectsListCount)

  const selectedItemCurrentPageNumber = useSelector((state) => state.currentPageNumber.savedProspectsValue)
  const actionMenu = prospectsActions.savedProspects.actionsMenu

  const askGivePrismFilters = useSelector((state) => state.askGivePrism.filters)
  const azureRole = useSelector((state) => state.superUserTenantSlice.azureRole)
  const superUser = useSelector((state) => state.superUserTenantSlice.isSuperUser)

  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    if (currentSelectedTab) {
      dispatch(updatedSavedProspectsSearchTerm({currentTerm: '', previousTerm: searchTerm}))
      setSearchTerm('')
      dispatch(getSavedProspectsPageNumber(1))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelectedTab, dispatch])

  useEffect(() => {
    if (superUser && !azureRole) {
      return
    }
    if (data?.savedLists?.length === 0) {
      conditionalSavedList()
    }
  }, [data, conditionalSavedList, superUser, azureRole])

  useEffect(() => {
    if (!loading && savedProspectList && savedProspectList?.getSavedList?.savedLists.length > 0) {
      dispatch(savedProspectsCount(savedProspectList.getSavedList.totalCount))
      dispatch(allSavedProspectsList(savedProspectList.getSavedList.savedLists))
      dispatch(getAllSavedProspectsData(savedProspectList.getSavedList.savedLists))
    }
  }, [savedProspectList, loading, dispatch, data])

  useMemo(() => {
    if (previousTerm !== currentTerm) {
      dispatch(getSavedProspectsPageNumber(1))
      conditionalSavedList()
    }
  }, [conditionalSavedList, currentTerm, previousTerm, dispatch])

  const handleChangePage = (event, newValue) => {
    if (newValue !== selectedItemCurrentPageNumber) {
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(newValue))
    }
  }

  const [rowData, setRowData] = useState()
  const [selectAll, setSelectAll] = useState(false)

  useEffect(() => {
    if (data && data?.savedLists.length > 0) {
      const updatedRows = data?.savedLists.map((row) => ({...row, selected: false}))
      setRowData(updatedRows)
    }
  }, [dispatch, data])

  const handleSelectAll = (event) => {
    const checked = event.target.checked
    const updatedRows = rowData?.map((row) => ({...row, selected: checked}))
    setSelectAll(checked)
    setRowData(updatedRows)
    dispatch(setAddToSavedProspects(checked ? updatedRows.map((row) => row.listName) : []))
  }

  const handleRowCheckboxChange = (event, obj) => {
    const checked = event.target.checked
    const updatedRows = rowData.map((row) => (row.listName === obj.listName ? {...row, selected: checked} : row))
    setRowData(updatedRows)
    const allSelected = updatedRows.every((row) => row.selected)
    setSelectAll(allSelected)
    const selectedIds = updatedRows.filter((row) => row.selected).map((row) => row.listName)
    dispatch(setAddToSavedProspects(selectedIds))
  }

  const [deleteList, {data: deleteData, loading: loadingData, error: errorData}] = useDeleteSavedList()

  const getCampaignAction = useSelector((state) => state.campaignAction)
  const {actionName, name} = getCampaignAction

  const [open, setOpen] = useState(false)
  const handleClose = () => {
    setOpen(false)
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false)

  const confirmDelete = (openBackdrop = false) => {
    openBackdrop && handleOpen()
    dispatch(setCampaignAction({actionName: '', name}))
    deleteList({
      variables: {
        listName: name,
        ...(azureRole ? {azureRole} : {})
      }
    })
  }

  useEffect(() => {
    if (actionName === 'deleteSavedList') {
      setOpenConfirmationPopup(true)
    }
    if (actionName === 'deleteList') {
      confirmDelete(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCampaignAction, actionName])

  const cancelDelete = useCallback(() => {
    dispatch(setCampaignAction({actionName: '', name}))
    setOpenConfirmationPopup(false)
  }, [dispatch, name])

  useEffect(() => {
    if (deleteData?.deleteList?.success && !loadingData && !errorData && actionName !== 'deleteSavedList') {
      handleClose()
      dispatch(getAllSavedProspectsData([]))
      dispatch(getSavedProspectsPageNumber(selectedItemCurrentPageNumber))
      cancelDelete()
      dispatch(setCampaignAction({actionName: '', name: ''}))
    }
  }, [deleteData, actionName, loadingData, errorData, dispatch, selectedItemCurrentPageNumber, cancelDelete])

  useEffect(() => {
    if (errorData && !loadingData) {
      handleClose()
      dispatch(setCampaignAction({actionName: '', name: ''}))
    }
  }, [errorData, loadingData, dispatch])

  const dispatchProspectsSetSearchTerm = (searchTerm) => {
    setSearchTerm(searchTerm)
    dispatch(updatedSavedProspectsSearchTerm({currentTerm: searchTerm, previousTerm: currentTerm}))
  }

  const handleTableRowClick = (event, row) => {
    dispatch(setCampaignView('openProspectList'))
    dispatch(setCampaignAction({actionName: 'openSavedList', name: row.listName}))
    dispatch(
      setAllConstituentsFilters({
        searchTerm: ''
      })
    )
    Object.keys(askGivePrismFilters).length > 0 && dispatch(getAllProspectsData([]))
  }

  const handleSort = () => {
    dispatch(getAllSavedProspectsData([]))
  }

  return (
    <div>
      <StyledBackdrop open={open}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      {searchPanelRequired && (
        <StyledBox>
          <SearchPanel
            width="35%"
            aria-label="search-for-a-user"
            data-testid="search-panel"
            setSearchTerm={dispatchProspectsSetSearchTerm}
            placeholder="Search for a name"
          />
        </StyledBox>
      )}
      <TableComponent
        headers={headers.defaultHeaders}
        explicitKeyLabelMapping={headers.explicitKeyLabelMapping}
        loading={loading}
        error={error}
        data={data?.savedLists}
        height={height}
        showCheckboxes={showCheckboxes}
        showAddColumnHeader={showAddColumnHeader}
        selectedItemCurrentPageNumber={selectedItemCurrentPageNumber}
        totalCount={totalCount}
        handleChangePage={handleChangePage}
        hasAccordian={hasAccordian}
        isActionRequired={hasActions}
        rowData={rowData}
        setRowData={setRowData}
        handleRowCheckboxChange={handleRowCheckboxChange}
        handleSelectAll={handleSelectAll}
        selectAll={selectAll}
        rows={paginationLimit.pagination.prospectsSegment}
        actionMenuList={actionMenu}
        handleTableRowClick={handleTableRowClick}
        searchTerm={searchTerm}
        handleDataSort={handleSort}
      />

      {openConfirmationPopup && (
        <ConfirmationPopup
          confirmationPopup={openConfirmationPopup}
          handleConfirmationClose={cancelDelete}
          handleConfirmation={() => confirmDelete(false)}
          loading={loadingData}
          errorMessage={errorData}
          name={name}
        ></ConfirmationPopup>
      )}
    </div>
  )
}

SavedProspects.propTypes = {
  height: PropTypes.number,
  showAddColumnHeader: PropTypes.bool,
  showCheckboxes: PropTypes.bool,
  hasActions: PropTypes.bool,
  hasAccordian: PropTypes.bool,
  searchPanelRequired: PropTypes.bool
}

export default SavedProspects
